//var $ = require('jquery');
require('owl.carousel');

var LMI = {
  common: {
    init: function() {

      //Turning off jsHint until it can be corrected to meet linting standards.
      /* jshint ignore:start */
      // Universal Analytics Setup
      (function() {
        // Add global GA variables
        window['GoogleAnalyticsObject'] = 'ga';
        window['ga'] = window['ga'] || function() {
            window['ga'].q = window['ga'].q || [];
            window['ga'].q.push(arguments);
          },
          window['ga'].l = 1 * new Date();
      })();

      $(".launch-app").click(function() {
        "function" === typeof immediateDownload && immediateDownload();
      });
      /* jshint ignore:end */

      //ClickTale code
      (function() {
        if (typeof(ClickTaleCreateDOMElement) !== "function") {
          ClickTaleCreateDOMElement = function(tagName) {
            if (document.createElementNS) {
              return document.createElementNS('http://www.w3.org/1999/xhtml', tagName);
            }
            return document.createElement(tagName);
          };
        }

        if (typeof(ClickTaleAppendInHead) !== "function") {
          ClickTaleAppendInHead = function(element) {
            var parent = document.getElementsByTagName('head').item(0) || document.documentElement;
            parent.appendChild(element);
          };
        }

        if (typeof(ClickTaleXHTMLCompliantScriptTagCreate) !== "function") {
          ClickTaleXHTMLCompliantScriptTagCreate = function(code) {
            var script = new ClickTaleCreateDOMElement('script');
            script.setAttribute("type", "text/javascript");
            script.text = code;
            return script;
          };
        }
        var scriptElement = new ClickTaleCreateDOMElement('script');
        scriptElement.type = "text/javascript";
        scriptElement.src = (document.location.protocol === 'https:' ? 'https://cdnssl.clicktale.net/www07/ptc/81e94ea3-750e-420b-a64c-fd410afa1a00.js' : 'http://cdn.clicktale.net/www07/ptc/81e94ea3-750e-420b-a64c-fd410afa1a00.js');
        document.body.appendChild(scriptElement);
      })();

      //DemandBase
      (function(d, b, a, s, e) {
        var t = b.createElement(a),
          fs = b.getElementsByTagName(a)[0];
        t.async = 1;
        t.id = e;
        t.src = s;
        fs.parentNode.insertBefore(t, fs);
      })
      (window, document, 'script', 'https://scripts.demandbase.com/7d5L0BQ5.min.js', 'demandbase_js_lib');
      //END CLICKTAG

    }
  },
  showMobileMenu: {
    init: function() {

      var nav = $('.nav-menu');
      var navWidth = 0;

      $('.top-menu > li').each(function() {
        navWidth += $(this).outerWidth(true);
      });

      var menuFunction = function() {
        var navContainer = $('header .nav-menu').innerWidth();

        //remove events
        $('.has-children').off('hover');
        $('.has-children > a').off('click');

        if (navWidth > navContainer) {
          //console.log('mobile');
          $('.mobile-menu').addClass('show');
          nav.addClass('mobile-nav');

          //click submenu dropdown
          $('.has-children > a').on('click', function(e) {
            //console.log('click');
            e.preventDefault();
            $('.sub-menu').toggleClass('show');
            // swap out data attribute on expand or collapse for tracking
            if ($('.has-children a').attr('data-gaeventaction') === 'header_enterprise-collapse') {
              $('.has-children a').attr('data-gaeventaction', 'header_enterprise-expand');
            } else if ($('.has-children a').attr('data-gaeventaction') === 'header_enterprise-expand') {
              $('.has-children a').attr('data-gaeventaction', 'header_enterprise-collapse');
            }
          });
        } else {
          //console.log('desktop');
          $('.mobile-menu').removeClass('show');
          nav.removeClass('open mobile-nav');

          //hover submenu dropdown
          $('.has-children').hover(function() {
            //console.log('hover');
            $('.sub-menu').toggleClass('show');
            // swap out data attribute on expand or collapse for tracking
            if ($('.has-children a').attr('data-gaeventaction') === 'header_enterprise-collapse') {
              $('.has-children a').attr('data-gaeventaction', 'header_enterprise-expand');
            } else if ($('.has-children a').attr('data-gaeventaction') === 'header_enterprise-expand') {
              $('.has-children a').attr('data-gaeventaction', 'header_enterprise-collapse');
            }
          });
        }
      };

      $(window).resize(function() {
        menuFunction();
      });

      menuFunction();

      $('.mobile-menu').on('click', function(e) {
        $('.nav-menu').toggleClass('open');
      });
    }
  },
  pickLanguage: {
    init: function() {
      $('.languages button').on('click', function(e) {
        $('.languages-drop').toggleClass('show');
      });
      $('.languages').mouseleave(function() {
        $('.languages-drop').removeClass('show');
      });
    }
  }
};

var LMIModules = {
  fire: function(func, funcname, args) {

    var ns = LMI;

    funcname = (funcname === undefined) ? 'init' : funcname;
    if (func !== '' && ns[func] && typeof ns[func][funcname] === 'function') {
      ns[func][funcname](args);
    }
  },

  loadEvents: function() {
    //fire common functions first
    LMIModules.fire('common');

    //find modules to load based on data attributes
    var moduleTrigger = $('[data-module]');

    if (moduleTrigger.length) {

      var moduleNames = [];
      var modules = [];

      //find the names of each trigger
      moduleTrigger.each(function() {
        names = $(this).data("module").split(' ');
        for (var i = 0; i < names.length; i++) {
          moduleNames.push(names[i]);
        }
      });

      //sort out duplicates
      for (var i = 0; i < moduleNames.length; i++) {
        if (($.inArray(moduleNames[i], modules)) === -1) {
          modules.push(moduleNames[i]);
        }
      }

      //load function based on data attribute value as names
      $.each(modules, function(i, classnm) {
        LMIModules.fire(classnm);
      });
    }
  }
};

$(document).ready(LMIModules.loadEvents);


// THIS SHOULD REALLY BE MOVED, I WILL TALK WITH ZEKE
var $sync1 = $(".big-images"),
  $sync2 = $(".thumbs"),
  $sync3 = $(".big-content"),
  flag = false,
  duration = 300;

$sync1.owlCarousel({
  items: 1,
  margin: 10,
  dots: false,
  loop: true
}).on('changed.owl.carousel', function(e) {
  if (!flag) {
    flag = true;
    $sync2.trigger('to.owl.carousel', [e.item.index, duration, true]);
    flag = false;
  }
});

$sync2.owlCarousel({
  responsive: {
    0: { items: 1, loop: true, margin: 30 },
    1025: { items: 5, dots: false, margin: 20 }
  }
}).on('click', '.owl-item', function() {
  $sync1.trigger('to.owl.carousel', [$(this).index(), duration, true]);
  $('.owl-item').removeClass('on');
  $(this).addClass('on');
}).on('changed.owl.carousel', function(e) {
  if (!flag) {
    flag = true;
    $sync1.trigger('to.owl.carousel', [e.item.index, duration, true]);
    flag = false;
  }
});

var j = $('.thumbs').find('.owl-item.active');
j.eq(0).addClass('on'); //left outermost item

$sync3.owlCarousel({
  items: 1,
  margin: 20,
  loop: true,
  dots: true
});

$('.new-slide').owlCarousel({
  items: 1,
  margin: 20,
  loop: true,
  dots: true,
  responsive: {
    /*0 : {touchDrag: true, mouseDrag: true, items: 1, loop:true,margin: 30, center: true},*/
    1025: { items: 5 }
  }
});



//OLD STUFF IN CASE THEY CHANGE THEIR MIND
//
//      if (window.innerWidth > 1091) {
//        $('.has-children a').on('click', function(e) {
//          $(this).find('.sub-menu').show();
//        }, function() {
//          $(this).find('.sub-menu').hide();
//        });
//      } else if (window.innerWidth <= 1090) {
//        var w_height = $(window).height();
//        $('.nav-menu').height(w_height - 40.5);
//        $('.has-children a').on('click', function(e) {
//         e.preventDefault();
//          e.stopPropagation();
//
//          $('.sub-menu').toggleClass('show');
//          //e.preventDefault();
//         //e.stopPropagation();
//        });
//   }
//



/** WEBPACK FOOTER **
 ** ./app/scripts/app.js
 **/